'use client';

import React from 'react';
import { Typography } from 'antd';
import { FileExclamationOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

type Props = {
  label: string;
  number?: string | null;
  message?: string | null;
};

const DocumentUnavailable: React.FC<Props> = ({ label, number, message }) => (
  <div
    role="status"
    style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      padding: 24,
      textAlign: 'center',
    }}
  >
    <FileExclamationOutlined
      style={{ fontSize: 40, color: 'var(--color-primary)' }}
    />
    <Title level={5} style={{ margin: 0 }}>
      {label} document not available
    </Title>
    {number && (
      <Text type="secondary">
        {label} no. {number}
      </Text>
    )}
    <Text type="secondary" style={{ maxWidth: 360 }}>
      {message ||
        `This ${label.toLowerCase()} has no document to show yet. Please check again later, or contact support if you need it urgently.`}
    </Text>
  </div>
);

export default DocumentUnavailable;
